import admin from './view';

export default [
  {
    path: '/', // 인증품목 목록
    redirect: 'standardItem',
  },
  {
    path: 'standardItem', // 인증품목 목록
    component: admin('/system/standardItem'),
  },
  {
    path: 'standardItem/edit', // 인증품목 등록
    component: admin('/system/standardItemEdit'),
  },
  {
    path: 'standardItem/:no', // 인증품목 상세
    component: admin('/system/standardItemDetail'),
  },
  {
    path: 'factoryJudgeEvalItem/', // 공장심사평가항목 목록
    component: admin('/system/factoryJudgeEvalItem'),
  },
  {
    path: 'factoryJudgeEvalItem/edit', // 공장심사평가항목 등록
    component: admin('/system/factoryJudgeEvalItemEdit'),
  },
  {
    path: 'factoryJudgeEvalItem/detail', // 공장심사평가항목 상세
    component: admin('/system/factoryJudgeEvalItemDetail'),
  },
  { path: '*', redirect: '/404' },
];



// WEBPACK FOOTER //
// ./src/router/admin/system.js